import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../Configuration/configuration.service';
import { LocalStorageService } from '../../../Shared/common/local-storage.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';

@Injectable({
  providedIn: 'root'
})
export class TarapiService {
  constructor(private http: HttpClient, private configService: ConfigurationService, private dataShareService: CharityDataShareServiceService, private lsService: LocalStorageService) { }
  private apiUrl = this.configService.getAPIBaseUrl(); // Base URL for your API
  //headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  saveTAR(tarmodel: any): Observable<any> {
    debugger
   // tarmodel.tarDetails.approvedbyTrustee_SecA = tarmodel.tarDetails.approvedbyTrustee_SecA.toString();
    const url = `${this.apiUrl}/TAR/SaveTAR`;
    return this.http.post(url, tarmodel);
  }
  GetTAR(id: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/TAR/GetTAR?id=`;
    return this.http.get(url + id);
  }
}
